import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import QrThemeService from "../../../Services/QRCodeServices/QrThemeService/QrThemeService";

import theme1 from "./images/T11.PNG"
import theme2 from "./images/T22.PNG"
import theme3 from "./images/T33.PNG"
import theme6 from "./images/T66.PNG"
import Theme7 from "./images/T77.PNG"
import theme8 from "./images/T88.PNG"
import theme9 from "./images/T99.PNG"
import digitalmenuai from "./images/THEMEDIGITAL.PNG"

const UpdateTheme = ({
  goToPreviousTab,
  goToNextTab,
  isValid,
  values,
  handleChange,
  initialValues,
}) => {
  const ThemeId = values.themeId;
  console.log("🚀 ~ ThemeId:", ThemeId);
  const [selectedThemeId, setSelectedThemeId] = useState(ThemeId); // Initial selected card
  useEffect(() => {
    setSelectedThemeId(values.themeId);
  }, [values.themeId]);

  console.log("🚀 ~ selectedThemeId:", selectedThemeId);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({}); // Store the content of the card for the modal

  // Function to fetch data from the API
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await QrThemeService.get();
      setData(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchData();
  }, []);

  // Handle card selection
  const handleCardSelect = (id) => {
    setSelectedThemeId(id); // Update local state for UI
    handleChange({ target: { name: "themeId", value: id } }); // Update form values
  };

  // Toggle Modal
  const toggleModal = () => setShowModal(!showModal);

  //static theme images

  const imageMap = {
    theme1,
    theme2,
    theme3,
    theme6,
    Theme7,
    theme8,
    theme9,
    digitalmenuai,
  };

  return (
    <>
      <div>
        <Row className="d-flex">
          {data?.map((item, index) => (
            <Col key={index} md={6} lg={6} sm={12} className="mb-4">
              <Card
                onClick={() => handleCardSelect(item.id)} // Select the card on click
                style={{
                  maxHeight: "40vh",
                  minHeight: "35vh",
                  border:
                    item.id === selectedThemeId ? "1px solid black" : "none",
                  cursor: "pointer",
                }}
              >
                <CardBody>
                  <img
                    // src={item?.imageUrl?.getCDNUrl()}
                    src={ imageMap[item?.title] ||"https://www.slideegg.com/image/multi-slide/61879/65963-google-slides-theme-food-01.png"} //static
                    // src={item?.title}
                    alt={item?.title}
                    className="img-fluid"
                    style={{ maxHeight: "20vh" }}
                  />
                  <hr />
                  <Row>
                    <Col md={10}>
                      <h6 className="text-center">{item?.title}</h6>
                    </Col>
                    <Col md={2}>
                      <i
                        className="ri-eye-line"
                        style={{ color: "green", cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent parent click
                          setModalContent(item); // Store the current item in state
                          toggleModal();
                        }}
                      ></i>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      <div className="d-flex justify-content-end align-items-end text-end mt-3 gap-4">
        <Button color="danger" onClick={goToPreviousTab}>
          Previous
        </Button>
        <Button
          color="success"
          onClick={() => {
            if (isValid) goToNextTab();
          }}
        >
          Next
        </Button>
      </div>

      <Modal
        isOpen={showModal}
        toggle={toggleModal}
        backdrop="static"
        size="lg"
      >
        <ModalHeader toggle={toggleModal}>
          {modalContent?.title || "Modal Title"}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={7}>
              <img
                src={`data:image/jpeg;base64,${modalContent?.image}`}
                alt={modalContent?.title}
                className="img-fluid"
                // style={{ maxWidth: "100%" }}
              />
            </Col>
            <Col md={5}>
              <p>{modalContent?.description || "No description available."}</p>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default UpdateTheme;
